import { render } from "./DogGenerator.vue?vue&type=template&id=47a91880&scoped=true"
import script from "./DogGenerator.vue?vue&type=script&lang=js"
export * from "./DogGenerator.vue?vue&type=script&lang=js"

import "./DogGenerator.vue?vue&type=style&index=0&id=47a91880&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47a91880"]])

export default __exports__